/**
 * Route for `deferred-deep-link`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { DeferredDeepLinkPage } from "../features/deferred-deep-link/DeferredDeepLinkPage";

export const deferredDeepLinkRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/deferred-deep-link",
	component: DeferredDeepLinkPage,
});

export default deferredDeepLinkRoute;
